import React, { useState } from 'react';
import { useStyles } from './style';
import { FastField, FieldProps } from 'formik';
import { FormikInput } from '../../../../../shared/components/formik-input';
import { Grid, IconButton, InputAdornment, Paper } from '@material-ui/core';
import SvgTrash from '../../../../../assets/icons/Trash';
import { CustomTimePicker } from '../../../../../shared/components/time-picker';
import { dateToString, stringToDate } from '../../../../../shared/helpers/stringHelper';
import { FreightRule } from '../../../../../api/freight-rule/types';

interface Props {
  day: string;
  index: number;
  onDelete: () => void;
  values: FreightRule;
  setFieldValue: (field: string, value: any) => void;
}

export const DaySettings: React.FC<Props> = ({
  day,
  index,
  onDelete,
  values,
  setFieldValue,
 }) => {
  const classes = useStyles();
  
  return (
    <Paper className={classes.paper} variant="outlined">
      <div className={classes.header}>
        <div className={classes.title}>
          {day} SETTINGS
        </div>
        <IconButton onClick={onDelete}>
          <SvgTrash className={classes.deleteIcon} />
        </IconButton>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <div className={classes.label}>Delivery Fee</div>
          <FastField name={`freight_day_settings_attributes.${index}.delivery_fee`}>
            {(fieldProps: FieldProps) => <FormikInput {...fieldProps}
              inputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>
              }}
              placeholder='0.00' height={48} />}
          </FastField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.label}>Order Cut-off Time</div>
          <div className={classes.cutoffTime}>
            <CustomTimePicker
              time={stringToDate(
                values.freight_day_settings_attributes![index]?.order_cut_off_time
              )}
              onSetTime={(date: Date | null) => {
                const timeStr = dateToString(date);
                setFieldValue(
                  `freight_day_settings_attributes[${index}].order_cut_off_time`,
                  timeStr
                );
              }}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div className={classes.label}>Minimum Order Value</div>
          <FastField name={`freight_day_settings_attributes.${index}.minimum_order_value`}>
            {(fieldProps: FieldProps) => <FormikInput {...fieldProps}
              inputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>
              }}
              placeholder='0.00' height={48} />}
          </FastField>
        </Grid>
      </Grid>
    </Paper>
  );
};
